const externalPartnerModel = {
  id: null,
  name: '',
  code: '',
  status: 'active',
  allowedOrderTypes: [],
  settings: {},
  createdAt: null,
  updatedAt: null,
}

export default {
  externalPartnerModel,
  externalPartnerStatuses: ['active', 'blocked'],

  partners: [],
  partnersTotal: 0,
  partnersLimit: 25,
  partnersPage: 1,

  partner: { ...externalPartnerModel },

  assignedUsers: [],
  assignedUsersTotal: 0,

  assignableUsers: [],
  assignableUsersTotal: 0,

  customerMappings: [],
  customerMappingsTotal: 0,

  customersLookup: [],
  customersLookupTotal: 0,
}
